var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Card",
    {
      staticClass: "monthly-overview-card",
      attrs: { title: "Monthly Overview" }
    },
    [
      _c("div", { staticClass: "flex flex-col h-full" }, [
        _c("div", { staticClass: "ai-insight" }, [
          _c("div", { staticClass: "flex items-start" }, [
            _c("div", { staticClass: "mr-2 mt-1" }, [
              _c("svg", {
                staticClass: "h-5 w-5 text-indigo-500",
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 20 20",
                  fill: "currentColor"
                }
              })
            ]),
            _vm._v(" "),
            _c("div", [
              _c("p", { staticClass: "text-gray-700" }, [
                _vm._v(
                  "\n            Last month's data backups peaked higher but this is likely due to the recent rise in deployments and some deployments increasing alert counts, which could be from big changes in the back end.\n          "
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "text-xs text-gray-500 mt-2" }, [
          _vm._v("\n      AI-generated insight • April 14, 2025\n    ")
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c12035d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c12035d4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cards/AICards/MonthlyOverviewCard.vue
// module id = null
// module chunks = 